import { Space } from '@/components/core-v2'

import { ProposedChangesDataRow } from './proposed-changes-data-row'
import { RowData } from './types'

export const ProposedChangesModalDataBlock = ({
  dataList,
  dataTestId
}: {
  dataList: RowData[]
  dataTestId: string
}) => (
  <Space
    isflex
    alignItems="flex-start"
    data-testid={dataTestId}
    flexGrow={1}
    justifyContent="center"
  >
    <Space isflex alignItems="center" flexDirection="column" flexGrow={1}>
      {dataList.find(data => data.name === 'Portfolio Id') ? (
        <>
          <ProposedChangesDataRow
            key={`change-property-${dataList[0].name}`}
            currentValue={dataList[0].value}
            propertyName={dataList[0].name}
          />
          {dataList.slice(1).map(property => (
            <ProposedChangesDataRow
              key={`change-property-${property.name}`}
              borderPosition="top"
              currentValue={property.value}
              highlighted={property.different}
              propertyName={property.name}
            />
          ))}
        </>
      ) : (
        <>
          {dataList.map(strategy => (
            <ProposedChangesDataRow
              key={`change-strategy-${strategy.name}`}
              borderPosition="bottom"
              currentValue={strategy.value ? 'Yes' : 'No'}
              highlighted={strategy.different}
              propertyName={strategy.name}
            />
          ))}
        </>
      )}
    </Space>
  </Space>
)
